import React from 'react';
import { createTabBarNavButton } from 'src/navigation/components/TabBarNavButton';
import { RootTab } from 'src/navigation/TabNavigation';
export function createTabScreen(entry, ctx, name, component) {
    const badge = entry.badge?.(ctx);
    return (React.createElement(RootTab.Screen, { name: name, component: component, options: {
            tabBarLabel: entry.label(ctx),
            tabBarIcon: ({ color, size }) => entry.renderIcon(color, size),
            tabBarBadge: badge && badge > 0 ? badge : undefined,
            tabBarButton: createTabBarNavButton(entry.to),
        } }));
}
